import { render, staticRenderFns } from "./bot-channels.vue?vue&type=template&id=2dd0ab5c&"
import script from "./bot-channels.vue?vue&type=script&lang=js&"
export * from "./bot-channels.vue?vue&type=script&lang=js&"
import style0 from "./bot-channels.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports